import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const CNFlag = createIcon({
  displayName: "CNFlag",
  viewBox: "0 0 96 64",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> China flag </title>
      <path d="M0 0H96V64H0V0Z" fill="#E20613" />
      <path
        d="M15.75 7.8194L17.939 14.5565H25.0228L19.2919 18.7202L21.4809 25.4573L15.75 21.2936L10.0191 25.4573L12.2081 18.7202L6.4772 14.5565H13.561L15.75 7.8194Z"
        fill="#FBBC04"
      />
      <path
        d="M31.4624 4.98381L31.4534 7.26912L33.6241 7.98389L31.4478 8.68152L31.4388 10.9668L30.1028 9.11267L27.9266 9.81029L29.2772 7.96674L27.9412 6.11258L30.1119 6.82736L31.4624 4.98381Z"
        fill="#FBBC04"
      />
      <path
        d="M38.8064 11.9465L37.8463 14.0204L39.522 15.5743L37.253 15.3021L36.2929 17.376L35.8506 15.1339L33.5816 14.8617L35.5773 13.7482L35.135 11.506L36.8107 13.06L38.8064 11.9465Z"
        fill="#FBBC04"
      />
      <path
        d="M36.6455 20.8552L37.3517 23.0287L39.637 23.0287L37.7881 24.372L38.4944 26.5454L36.6455 25.2021L34.7966 26.5454L35.5028 24.372L33.654 23.0287L35.9393 23.0287L36.6455 20.8552Z"
        fill="#FBBC04"
      />
      <path
        d="M31.9167 27.4972L31.7577 29.777L33.8768 30.6327L31.6594 31.1859L31.5004 33.4657L30.289 31.5279L28.0717 32.0812L29.5403 30.3302L28.3289 28.3924L30.448 29.2481L31.9167 27.4972Z"
        fill="#FBBC04"
      />
      <path
        d="M0 0V-1H-1V0H0ZM96 0H97V-1H96V0ZM96 64V65H97V64H96ZM0 64H-1V65H0V64ZM0 1H96V-1H0V1ZM95 0V64H97V0H95ZM96 63H0V65H96V63ZM1 64V0H-1V64H1Z"
        fill="#767676"
      />
    </>
  )
});
